import React from 'react'
import * as Building from 'modules/building/components/Reference'
import * as Logo from 'components/Logo'
import * as TopBanner from 'components/TopBanner'
import * as styles from './styles.module.scss'

/**
 */
const Title = () => (
  <div className={styles.TitleContainer}>
    <h1 className={styles.Heading}>
      <Building.Properties.NameEn className={styles.TitleText} />
      {/* <small> */}
      <Building.Properties.NameJa className={styles.TitleSmallText} />
      {/* </small> */}
    </h1>
  </div>
)

/**
 */
export const BannerAndTitle = () => {
  return (
    <div className={styles.BannerAndTitle}>
      <TopBanner.Content className={styles.TopBanner} />
      <Title />
    </div>
  )
}

/**
 */
const Header = () => {
  return (
    <div className={styles.Header}>
      <div className={styles.Header_Container}>
        <Logo.Content className={styles.Header_Logo} />
      </div>
    </div>
  )
}

/**
 */
export const Content = () => {
  return (
    <>
      <Header />
      <BannerAndTitle />
      {/* <TopBanner.Content className={styles.TopBanner} /> */}
      {/* <Title /> */}
    </>
  )
}
